<template>
  <naj-modal
    ref="pdfLawsuitPaperModal"
    :width="1000"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    :title="local.lawsuitPaper.title"
    content-class="lawsuit-paper-contents"
    @onClose="closeModal"
  >
    <div
      v-if="loading"
      class="loader-holder"
    >
      <naj-loader></naj-loader>
    </div>
    <template v-else>
      <div
        v-if="lawsuitPaperDocument !== null"
        class="pdf-container"
      >
        <div class="pdf-wrapper">
          <div class="pdf-holder">
            <embed :src="fileUrl">
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-center pa-5"
      >
        <h3>{{ local.common.noData }}</h3>
      </div>
    </template>
  </naj-modal>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'PdfLawsuitPaperModal',
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    modalVisibility: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      lawsuitPaperDocument: null,
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.lawsuitPaperDocument, false);
    },
  },
  watch: {
    modalVisibility(newValue, oldValue) {
      if (newValue === true && oldValue !== newValue) {
        this.$refs.pdfLawsuitPaperModal.show();
        this.getLawsuitPaperPdf();
      } else {
        this.$refs.pdfLawsuitPaperModal.close();
      }
    },
  },
  mounted() {
    if (this.modalVisibility) {
      this.$refs.pdfLawsuitPaperModal.show();
      this.getLawsuitPaperPdf();
    }
  },
  methods: {
    ...mapActions(['generateLawsuitPaperPdf']),
    getLawsuitPaperPdf() {
      this.loading = true;
      this.lawsuitPaperDocument = null;
      this.generateLawsuitPaperPdf(this.caseObjectKey)
        .then((res) => {
          this.lawsuitPaperDocument = `data:application/pdf;base64,${res.data}`;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeModal() {
      this.lawsuitPaperDocument = null;
      this.$emit('modalClose');
    },
  },
};
</script>

<style lang="scss" scoped>
.pdf-container {
  width: 100%;
  height: 100%;

  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;

    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
    }
  }
}

embed {
  width: 100%;
  height: 600px;
}
</style>
